<script>
  /**
   * @type {string} content to be shown in the screen
   */
  export let content
</script>

<div class="mt-6 flex w-1/2 justify-center text-center text-base text-gray-400">
  <h1>{content}</h1>
</div>
<div class="mt-6 flex gap-3">
  <button
    on:click={() => {
      window.location.reload()
    }}
    type="button"
    class="flex h-9 items-center justify-center rounded-md border border-[#a0a1a533] bg-red-500 px-2 text-sm font-medium text-white hover:bg-red-600 hover:text-white focus:outline-none active:bg-red-500 disabled:cursor-not-allowed disabled:bg-red-500/50 lg:px-4"
  >
    <span>
      <i class="fa-solid fa-circle-play" />
    </span>
    <span class="select-none">&nbsp;&nbsp;Retry&nbsp;to&nbsp;Continue&nbsp;</span>
  </button>
  <slot />
</div>
